export default __webpack_public_path__ + "static/media/Camera.12019a8e.svg";